<template>
  <el-dialog :visible.sync="visible" class="overflow-hidden" top="0" :before-close="handleClose">
    <div class="">
      <div class="content text-center mb-10">
        <p class="font-bold text-xl text-black mb-6">{{ $t('promotion.fundsGrowthPromotion.button.optOut') }}</p>
        <div class="dialog_desc mb-10">
          <p>{{ $t('promotion.fundsGrowthPromotion.dialog.optOutReminder') }}</p>
          <p>{{ $t('promotion.fundsGrowthPromotion.dialog.optOutDesc1') }}</p>
        </div>
        <el-form :model="form" ref="form" :rules="formRules">
          <SelectForm
            v-model="form.selectedOptOutAccount"
            name="selectedOptOutAccount"
            :label="$t('promotion.fundsGrowthPromotion.accountNumber')"
            :placeholder="$t('promotion.fundsGrowthPromotion.selectAccount')"
            class="showPlaceholder"
            multiple
          >
            <el-option
              v-for="item in activeAccounts"
              :key="item.mt4Account"
              :label="item.mt4Account"
              :value="item.mt4Account"
            >
            </el-option>
          </SelectForm>
        </el-form>
      </div>
      <div slot="footer" class="mb-10">
        <span class="dialog-footer">
          <el-button
            class="el-button fgp_secondary_button dialog-btn el-button--default hover:!border-lightBlueG0 hover:!bg-lightBlueG0 hover:!text-inherit !border-darkBlueG0"
            @click="handleClose"
          >
            {{ $t('common.button.back') }}
          </el-button>

          <el-button
            class="blue_button fgp_blue_button disabled:border-[#cdcfd3]! disabled:bg-transparent!"
            @click="handleOptOut"
          >
            {{ $t('promotion.fundsGrowthPromotion.button.optOut') }}
          </el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { apiOptOutWithAccounts } from '@/resource';
import { validateRequireArray } from '@/util/validation';

export default {
  name: 'optOutModal',
  props: {
    optOutModalModalVisible: Boolean,
    campaignId: Number,
    activeAccounts: Array
  },
  data() {
    return {
      visible: false,
      form: {
        selectedOptOutAccount: []
      },
      formRules: {
        selectedOptOutAccount: [
          {
            required: true,
            validator: validateRequireArray,
            trigger: 'change'
          }
        ]
      },
      tncLink: 'https://www.google.com/'
    };
  },
  watch: {
    optOutModalModalVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.$emit('update:optOutModalModalVisible', bool);
    }
  },
  methods: {
    handleClose() {
      this.visible = !this.visible;
      this.resetForm();
    },
    handleOptOut() {
      this.$refs.form?.validate(valid => {
        if (valid) {
          const reqBody = {
            campaignId: this.campaignId,
            optIn: false,
            accountMt4DtoList: this.form.selectedOptOutAccount.map(acc => {
              return {
                mt4Account: acc,
                datasourceId: this.activeAccounts.find(i => i.mt4Account === acc).datasourceId
              };
            })
          };

          apiOptOutWithAccounts(reqBody).then(resp => {
            if (resp.data.data) {
              this.handleClose();
              location.reload();
            } else {
              this.$message({
                message: this.$t('common.field.failed'),
                type: 'error',
                duration: 5000
              });
            }
          });
        } else return false;
      });
    },
    resetForm() {
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/fundsGrowthPromotion.scss';
</style>
